import { Navigate } from "react-router-dom";

const NotFoundRedirect = () => {
    const isLogin = localStorage.getItem("isLoggedIn") === "true";

    return isLogin
        ? <Navigate to="/dashboard" replace />
        : <Navigate to="/" replace />;
};

export default NotFoundRedirect;